import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useIsTrustedPartner } from '@modules-deprecated/app/umbrellas'

import { ReactComponent as AnnualReportDIYLogo } from '../../../assets/images/integrations/annual-report-diy.svg'
import { useEmberRouter } from '../../../contexts/emberRouterContext'
import { EmberRoute } from '../../../enums/emberRoute'
import { Scope } from '../../../enums/scope'
import { isAuthorized } from '../../../utils/isAuthorized'
import { IntegrationId } from '../enums/integrationId'
import { IntegrationItem } from '../types/integrationItem'

export const useAnnualReportDIYIntegration = (): IntegrationItem => {
  const { t } = useTranslation()
  const { navigate } = useEmberRouter()
  const { isTrustedPartner, isLoading: isTrustedPartnerLoading } = useIsTrustedPartner()

  const buttonHandler = useCallback(() => {
    navigate(EmberRoute.AnnualReports)
  }, [navigate])

  const isHidden = !isAuthorized(Scope.AnnualReportRead, false, !isTrustedPartner)

  return {
    id: IntegrationId.AnnualReportDIY,
    name: t('integrations.card.annual_report_diy.title'),
    description: t('integrations.card.annual_report_diy.body'),
    readMoreLink: 'https://www.billy.dk/aarsregnskab/',
    imageNode: <AnnualReportDIYLogo />,
    isHiddenLoading: isTrustedPartnerLoading,
    isHidden,
    buttonHandler,
    buttonText: t('integrations.card.annual_report_diy.button.activate'),
    statusLabelNode: null,
    isStatusLoading: false,
  }
}
